import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var mockMaxVersion = 99999;

var noop = function noop(p) {
  return null;
};

var _default = function _default() {
  _classCallCheck(this, _default);
};

_defineProperty(_default, "getQpInfo", function (hybridId) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

  if (callback) {
    callback({
      version: mockMaxVersion
    });
  }
});

_defineProperty(_default, "getOriginQpInfo", function (hybridId) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

  if (callback) {
    callback({
      version: mockMaxVersion
    });
  }
});

export { _default as default };